import { TextNodeType } from "@tm/isomorphic-utils";
import { useBreakpointV2 } from "@tm/ui-widgets";
import React from "react";
import FlexComp from "../FlexComp/FlexComp";
import FormattedText from "../FormattedText/FormattedText";
import { ImageComponent } from "../ImageComponent/ImageComponent";
import ToolTipComp from "../ToolTipComp/ToolTipComp";
import {
  FooterBorder,
  FooterDescription,
  FooterSectionContainer,
} from "./FooterSectionComp.style";

interface FooterSectionProps {
  icon?: string;
  description: TextNodeType;
  background?: {
    startColor: string;
    endColor?: string;
  };
  border?: {
    gradient: string[];
  };
  tooltip?: {
    icon?: string;
    description: TextNodeType;
  };
}

const FooterSectionComp: React.FC<FooterSectionProps> = ({
  icon,
  description,
  background,
  border,
  tooltip,
}) => {
  const device = useBreakpointV2();
  const [isHovered, setIsHovered] = React.useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const backgroundStyle = {
    background: `linear-gradient(to right, ${background?.startColor}, ${background?.endColor})`,
  };

  return (
    <FooterSectionContainer style={{ ...backgroundStyle }}>
      <FooterBorder borderGradient={border?.gradient} />
      <FlexComp padding="12px 20px" gap="8px" alignItems="center">
        <ImageComponent width="16px" height="16px" alt="icon" src={icon} />
        <FooterDescription>
          <FormattedText value={description} />
        </FooterDescription>
        {tooltip?.icon && (
          <>
            <ImageComponent
              width="16px"
              height="16px"
              alt="icon"
              src={tooltip?.icon}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
            {isHovered && (
              //TODO: Check Moving tooltip to portal
              <ToolTipComp
                handleMouseEnter={handleMouseEnter}
                handleMouseLeave={handleMouseLeave}
                left={device === "lg" ? "43%" : "134px"}
                top={device === "lg" ? "-15px" : "-80px"}
                toolTipArrow={device === "lg" ? "left" : "bottom"}
                width="247px"
                backgroundColor="black"
              >
                <FormattedText value={tooltip.description} />
              </ToolTipComp>
            )}
          </>
        )}
      </FlexComp>
    </FooterSectionContainer>
  );
};

export default FooterSectionComp;
